import '@src/styles/companyInformation/creditcards/creditCardSummary.scss';
import { Alert } from 'antd';
import { CustomImage, Text } from '@src/components';
import React, { useMemo } from 'react';
import iconInfo from '@src/assets/icons/icon-info.svg';
import { useDispatch, useSelector } from 'react-redux';
import uniqBy from 'lodash/uniqBy';
import { setEditingCard } from '@src/store/slice/mobilExpressSlice';
import { cardNumberMask } from '@src/utils/utils';

const CreditCardSummaryPage = () => {
  const dispatch = useDispatch();
  const { editingCard } = useSelector((state) => state?.mobilExpress);
  const { customerVouList } = useSelector((state) => state?.customer);

  const selectedVou = useMemo(() => {
    if (!editingCard.selectedVou) return [];
    return editingCard.selectedVou;
  }, [editingCard]);

  const vouList = useMemo(() => {
    return uniqBy(customerVouList, (d) => d.vouId);
  }, [customerVouList.length]);

  const changePage = () => {
    dispatch(setEditingCard({ current: 0 }));
  };

  const selectedVouObjects = vouList?.filter((vou) => selectedVou.includes(vou.vouId)) || [];

  return (
    <>
      <p>
        <b>
          <Text t="pleaseConfirmYourInformation" />
        </b>
      </p>
      <div className="credit-card-summary-card">
        <div className="summary-content product-type-content">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span
              style={{
                textAlign: 'right',
                width: '100%',
              }}
            >
              <button id="changeButton" onClick={changePage}>
                <Text t="change" />
              </button>
            </span>
          </div>
          <div className="product-type-text">
            {selectedVouObjects.map((v, i) => (
              <>
                {v.vouName}
                {i < selectedVouObjects.length - 1 && <>, </>}{' '}
              </>
            ))}
          </div>
        </div>
        <hr />
        <div className="summary-content credit-card-info-content">
          <h5>
            <Text t="creditCardInformation" />
          </h5>
          <div className="credit-card-info-text">
            {' '}
            <Text t="nameOnCard3" /> <span>{editingCard.creditCard?.cardHolderName}</span>
          </div>
          <div className="credit-card-info-text">
            {' '}
            <Text t="cardNumber2" />:{' '}
            <span>{cardNumberMask(editingCard.creditCard?.cardNumber)}</span>
          </div>
          <div className="credit-card-info-text">
            {' '}
            <Text t="expirationDate2" />{' '}
            <span>
              {editingCard.creditCard?.lastMonth}/{editingCard.creditCard?.lastYear}
            </span>
          </div>
        </div>
        {editingCard?.automaticPayment && (
          <>
            <hr />
            <div className="summary-content automatic-payment-instruction-content">
              <p>
                <Text t="automaticPaymentInstruction" />
              </p>

              {selectedVouObjects.map((vou) => (
                <>
                  <h5>{vou.vouName}</h5>
                </>
              ))}

              <Alert
                message={
                  <div className="alert-message-contain">
                    <CustomImage src={iconInfo} />{' '}
                    <div className="alert-message-content">
                      <p>
                        <Text t="whatIsAutomaticPaymentInstruction" />
                      </p>
                      <div className="info-list">
                        <span className="info-text-item">
                          <Text t="theCardForWhichYouHaveGivenAn" />
                        </span>
                        <span className="info-text-item">
                          {' '}
                          <Text t="forYourSelectedEdenredProductsOurSystemWill" />
                        </span>
                      </div>
                    </div>
                  </div>
                }
                banner
                showIcon={false}
                className="custom-alert-info"
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CreditCardSummaryPage;
